export default {
  // "login.headline": "映画ランドチケッティングシステムへようこそ",
  "login.headline": "CINEMA PLATFORM へようこそ",
  "login.passwordHasExpired": "パスワードの有効期限が過ぎました。",
  "login.plsUpdateYourPassword": "パスワードの更新をお願いします",
  "login.oldPassword": "パスワード（旧）",
  "login.plsEntertOldPassword": "パスワード（旧）を入力してください",
  "login.newPassword": "パスワード（新）",
  "login.plsEntertNewPassword": "パスワード（新）を入力してください",
  "login.confirmNewPassword": "パスワード確認（新）",
  "login.plsEnterConfirmNewPassword": "パスワード確認（新）を入力してください",
  "login.newPasswordDifferent": "バスワード（新）とバスワード確認（新）が一致ではありません",
  "login.newPasswordCanNotBeTheSame": "パスワード（旧）とパスワード（新）が同じです。違うパスワードにしてください",
  "login.passwordError": "パスワードが違います",
  "login.accountInactivated": "こちらのアカウントは、現在無効になっています。",
};